import { Component, Vue, Prop } from 'vue-property-decorator';
import { Field, TextField, Btn, FormButtonDisabler, IModalComponent, Validations } from '@samc/centricity-core';
import { IReviewType } from '@/Interfaces';

@Component({
  name: 'review-type-form-modal',
  components: { Field, TextField, Btn, FormButtonDisabler }
})
export default class ReviewTypeFormModal extends Vue implements IModalComponent {
  @Prop() public addCloseProp!: (callback: () => Promise<IReviewType | undefined>) => void;
  @Prop() public closeProp!: () => void;

  public name: string = '';
  public description: string = '';
  public showValidations: boolean = false;
  public get validations(): Validations<IReviewType> {
    let result: any = {}
    if (this.name.length == 0) {
      result.name = 'Review Type Is Required!';
    }
    return result;
  }

  public mounted() {
    this.addCloseProp(async () => {
      this.showValidations = true;
      if (Object.keys(this.validations).length === 0) {
        return {
          name: this.name,
          description: this.description,
          importProcessId: null
        } as IReviewType;
      }
    });
  }
}